<span cdkOverlayOrigin #trigger="cdkOverlayOrigin" (mouseover)="openWithMouseOver()" (click)="toggleWithClick()" class="current-value" [class.opened]="isListOpened" accesskey="5"><img class="earth" width="24" height="24" loading="eager" src="images/icons/earth.svg" alt="earth" /> {{ selectedLocale | uppercase }} <img width="14" height="14" loading="eager" class="arrow" src="images/icons/arrow-down.svg" alt="arrow-down" /></span>
<!-- <em>(5)</em> -->

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isListOpened">
  <div (mouseleave)="isListOpened = false" class="list-container">
    <cdk-virtual-scroll-viewport itemSize="28" class="viewport" minBufferPx="300" maxBufferPx="400">
      <h2 class="list-subtitle">{{ 'Most popular' | translate }}</h2>
      <ul class="list-popular">
        <li class="list-item" *ngFor="let item of popularLanguages | orderBy : 'value'" [ngClass]="{ selected: item.isSelected }">
          <a class="list-item__text" (click)="selectLanguage(item)">{{ item.language | replaceUnsupportedSymbols }}</a>
        </li>
      </ul>
  
      <h2 class="list-subtitle">{{ 'All languages' | translate }}</h2>
      <ul>
        <li class="list-item" *cdkVirtualFor="let item of filteredLanguages | orderBy : 'value'" [ngClass]="{ selected: item.isSelected }">
          <a class="list-item__text" (click)="selectLanguage(item)">{{ item.language | replaceUnsupportedSymbols }}</a>
        </li>
      </ul>
    </cdk-virtual-scroll-viewport>
  </div>
</ng-template>
